import { render, staticRenderFns } from "./platform-service-params.vue?vue&type=template&id=f792da64&scoped=true&"
import script from "./platform-service-params.vue?vue&type=script&lang=js&"
export * from "./platform-service-params.vue?vue&type=script&lang=js&"
import style0 from "./platform-service-params.vue?vue&type=style&index=0&id=f792da64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f792da64",
  null
  
)

export default component.exports